import React from "react";
import PropTypes from "prop-types";

const ReferIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.56 3.6C16.8984 3.2256 17.1 2.7576 17.1 2.24928C17.1 1.0224 15.853 0 14.4 0C12.0427 0 10.5653 1.36512 9.90287 2.35584C9.23903 1.36512 7.75728 0 5.4 0C3.94704 0 2.7 1.0224 2.7 2.25072C2.7 2.7576 2.90016 3.2256 3.24 3.60144H0V9H0.899999V16.2C3.47616 17.3347 6.5664 18.0029 9.89999 18C13.2336 17.9971 16.3253 17.339 18.9 16.2V9H19.8V3.6H16.56ZM5.6376 1.54368C7.99344 1.54368 9 3.6 9 3.6H5.6376C5.01408 3.6 4.50864 3.1176 4.50864 2.55744C4.50864 1.99728 5.01408 1.54368 5.6376 1.54368ZM7.2 16.0517C5.6088 15.876 4.09824 15.5448 2.7 15.0869V9H7.2V16.0517ZM7.2 7.2H1.8V5.4H7.2V7.2ZM10.8 16.1813C10.5019 16.1928 10.2024 16.2 9.89999 16.2H9.89423C9.59327 16.2 9.29663 16.1928 9 16.1827V5.4H10.8V16.1813ZM14.1797 1.54368C14.8032 1.54368 15.3086 1.99728 15.3086 2.55888C15.3086 3.12048 14.8032 3.60144 14.1797 3.60144H10.8C10.8 3.6 11.8238 1.54368 14.1797 1.54368ZM17.1 15.0869C15.7032 15.5448 14.1912 15.8731 12.6 16.0488V9H17.1V15.0869ZM18 7.2H12.6V5.4H18V7.2Z"
        fill={fill}
      />
    </svg>
  );
};

ReferIcon.defaultProps = {
  width: 20,
  height: 18,
  fill: "#E31C79",
};

export default ReferIcon;
